import { render, staticRenderFns } from "./DiscountCodeCreateAndUpdateFormItems.vue?vue&type=template&id=27a1ca24&"
import script from "./DiscountCodeCreateAndUpdateFormItems.vue?vue&type=script&lang=js&"
export * from "./DiscountCodeCreateAndUpdateFormItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports